import { useState } from "react";
export function useProgressRefresh(progressModal, originalRefresh) {
    return async (message = 'Loading...', successMessage = 'Refreshed', focusId) => {
        progressModal[0]({ focusId, message, successMessage });
        try {
            await originalRefresh();
            progressModal[1](true);
        }
        catch (e) {
            progressModal[1](false);
        }
    };
}
/** Wraps a query change input function with a progress modal */
export function useProgressChangeInput(progressModal, originalChangeInput) {
    return async (argument, message = 'Reordering...', successMessage = 'Done', focusId) => {
        progressModal[0]({ focusId, message, successMessage });
        try {
            await originalChangeInput(argument);
            progressModal[1](true);
        }
        catch (e) {
            progressModal[1](false);
        }
    };
}
/** Wraps a query change input function with a progress modal, but also keeps the original state */
export function useProgressPatchInput(progressModal, initState, originalChangeInput) {
    const [state, setState] = useState(initState);
    return async (reset, argument, message = 'Reordering...', successMessage = 'Done', focusId) => {
        try {
            const newState = reset ? argument : { ...state, ...argument };
            setState(newState);
            progressModal[0]({ focusId, message, successMessage });
            await originalChangeInput(newState);
            progressModal[1](true);
        }
        catch (e) {
            progressModal[1](false);
        }
    };
}
